import { Overlay, OverlayContainer } from '@angular/cdk/overlay';
import { Platform } from '@angular/cdk/platform';
import { ViewportRuler } from '@angular/cdk/scrolling';
import { DOCUMENT } from '@angular/common';
import { Component, Inject, Injector, OnDestroy, OnInit } from '@angular/core';
import { ConfigService } from '@app/finxone-web-frontend/app/lib/services/config-service/config-service.service';
import { PasswordService } from '@app/finxone-web-frontend/app/lib/services/password-service/password-service.service';
import { AutoDestroy } from '@finxone-platform/shared/base-types';
import {
  BaseCssProperties,
  ProviderClass,
  baseCssConfigStyle,
} from '@finxone-platform/shared/sys-config-types';
import { Subject, interval, map, takeWhile, tap } from 'rxjs';
import { OverlayWidgetComponent } from '../overlay/overlay';

@Component({
  standalone: false,
  selector: 'finxone-web-frontend-resend-links-widget',
  templateUrl: './resend-links-widget.component.html',
  styleUrls: ['./resend-links-widget.component.scss'],
})
export class ResendLinksWidgetComponent
  extends OverlayWidgetComponent<ResendLinksWidgetComponent>
  implements OnInit, OnDestroy
{
  @AutoDestroy destroy$: Subject<void> = new Subject<void>();
  public countdownValue = 0;
  public globalStylingClass = '';
  public isAllowedGlobalStyling = false;

  public buttonLabel = 'Resend Link';
  public iconSize?: baseCssConfigStyle;
  private _dataIn: ProviderClass<any>;

  constructor(
    configService: ConfigService,
    dataIn: ProviderClass<any>,
    overlay: Overlay,
    injector: Injector,
    _viewportRuler: ViewportRuler,
    _platform: Platform,
    _overlayContainer: OverlayContainer,
    private passwordService: PasswordService,
    @Inject(DOCUMENT) private document: Document,
  ) {
    super(
      dataIn,
      overlay,
      injector,
      ResendLinksWidgetComponent,
      _viewportRuler,
      _platform,
      _overlayContainer,
      configService,
    );
    if (this.dataIn != undefined && this.dataIn != null) {
      this.attri = this.dataIn.attri;
    }
    this.contentStyle = this.configService.getSpecificBaseCssStyle(this.attri, [
      BaseCssProperties.MARGIN,
      BaseCssProperties.PADDING,
      BaseCssProperties.COLOR,
      BaseCssProperties.TEXTALIGN,
      BaseCssProperties.BACKGROUND_COLOR,
      BaseCssProperties.BORDER,
      BaseCssProperties.V_ALIGN,
      BaseCssProperties.TEXTALIGN,
      BaseCssProperties.FONT_SIZE,
      BaseCssProperties.TEXT_ITALIC,
      BaseCssProperties.TEXT_BOLD,
      BaseCssProperties.TEXT_FONT_STYLE,
      BaseCssProperties.BOX_SHADOW,
    ]);
  }

  ngOnInit() {
    this.startCountdown(30);
    this.getGlobalStyling();
  }

  private getGlobalStyling() {
    if (
      this.dataIn.attri.widgetProperties?.['globalStylingClass'] &&
      this.dataIn.attri.widgetProperties?.['globalStyling']
    ) {
      this.globalStylingClass = this.dataIn.attri.widgetProperties?.['globalStylingClass'] ?? '';
      this.isAllowedGlobalStyling = this.dataIn.attri.widgetProperties?.['globalStyling'] ?? false;
    }
  }

  callResendAPI() {
    const urlParams = new URL(this.document.location.href).searchParams;
    const email = urlParams.get('email') ?? '';
    if (email) {
      this.passwordService.resetPasswordEmailOnly(email).subscribe({
        next: () => {
          this.startCountdown(30);
        },
        error: (err) => {},
      });
    }
  }

  startCountdown(seconds: number) {
    this.countdownValue = seconds;
    interval(1000)
      .pipe(
        map((i) => seconds - i - 1), // Adjust to ensure accurate countdown
        takeWhile((value) => value >= 0),
        tap((value) => {
          this.countdownValue = value;
          this.updateButtonLabel();
        }),
      )
      .subscribe();
  }

  updateButtonLabel() {
    if (this.countdownValue > 0) {
      this.buttonLabel = `Resend Link (${this.countdownValue})`;
    } else {
      this.buttonLabel = 'Resend Link';
    }
  }

  doAction() {
    if (this.countdownValue === 0) {
      this.callResendAPI();
    }
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.doAction();
    }
  }
}
